import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../Constants';
import restClient from '../../MainFrame/action/APIClient';

var GetBlockedPublicEmailAction = function () {}

GetBlockedPublicEmailAction.prototype = {
    getBlockedPublicEmailDomain: function (domain) {
        restClient.integrationsread(domain, function (error, response) {
            if (error) {
                AppDispatcher.dispatch({
                    actionType: Constant.GET_BLOCKED_PUBLIC_EMAIL_DOMAIN,
                    data: error
                });
            } else if(response!=null) {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.GET_BLOCKED_PUBLIC_EMAIL_DOMAIN,
                    data: response
                });
            }
        })
    }
}

export default new GetBlockedPublicEmailAction();